'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
var SelectList = require('../../../components/SelectList/SelectList.js');
require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var useLanguage = require('../../../hooks/language/useLanguage.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ReturnReasonsEdit = _ref => {
  let {
    onChange
  } = _ref;
  const {
    rawValue: removeLabel = ''
  } = useLanguage["default"]({
    langKey: 'returnsReasonsEditRemoveLabel',
    asString: true
  });
  const {
    rawValue: continueLabel = ''
  } = useLanguage["default"]({
    langKey: 'returnsReasonsEditContinueLabel',
    asString: true
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsEditTitle"
  })), /*#__PURE__*/React__default["default"].createElement(SelectList["default"], {
    onChange: onChange,
    options: [{
      value: 'remove',
      label: removeLabel
    }, {
      value: 'continue',
      label: continueLabel
    }]
  }));
};

exports["default"] = ReturnReasonsEdit;
